import React from 'react'
import PropTypes from 'prop-types'
import { StyledBqButton, StyledBqIcon as BqIcon } from './styles.js'

export default function SortButton({ name, sortOrder, toggleSort }) {
  return (
    <StyledBqButton variant='ghost' appearance='text' size='small' onBqClick={() => toggleSort(name)}>
      {!sortOrder && <BqIcon name='arrows-down-up' weight='bold' size='16' color='icon--brand' />}
      {sortOrder?.order === 'asc' && <BqIcon name='arrow-up' weight='bold' size='16' color='icon--brand' />}
      {sortOrder?.order === 'dsc' && <BqIcon name='arrow-down' weight='bold' size='16' color='icon--brand' />}
    </StyledBqButton>
  )
}

SortButton.propTypes = {
  name: PropTypes.string.isRequired,
  sortOrder: PropTypes.shape({
    order: PropTypes.oneOf(['asc', 'dsc'])
  }),
  toggleSort: PropTypes.func.isRequired
}
